module.exports = __webpack_public_path__ + "img/IMG_20210930_115519 1.8d0f2333.png";